
import { Options, Vue } from 'vue-class-component'
import { mapState, mapMutations } from 'vuex'


@Options({
    data () {
        return {
            list: [],
            selects: [],
            allSelected: false,
            blessings: ['团团圆圆，平安喜乐！', '今夜的月亮，散着团圆的光！', '闹元宵，汤圆吃出幸福新一年！', '月圆心甜，幸幸福福新一年！', '元宵月，愿与你共赏团圆！', '甜蜜汤圆，是节日最好的礼物！', '闹花灯，吃汤圆，和和美美又一年！', '点一盏元宵灯；吃一碗甜汤圆！'],
            isGeting: false
        }
    },
    computed: {
        ...mapState(['aid', 'userInfo', 'shareData', 'activityData'])
    },
    created () {
        this.getList(this.$route.query.type)
    },
    mounted () {
        this.activityData && this.$common.pageLoaded()
        this.shareData.title && this.$common.onshare(this.shareData)
        this.$common.track('load', '进入做汤圆页面')
    },
    methods: {
        ...mapMutations(['SET_USERINFO', 'SET_HBDATA', 'SET_DIALOGDATA']),
        getList (type: string) {
            this.list  = [
                {
                    title: require('@/assets/img/select_title_01.png'),
                    list: [
                        {
                            name: '甜蜜<br>汤圆粉',
                            img: require('@/assets/img/make_zc_01.png')
                        },
                        {
                            name: '幸福<br>汤圆粉',
                            img: require('@/assets/img/make_zc_02.png')
                        },
                        {
                            name: '喜乐<br>汤圆粉',
                            img: require('@/assets/img/make_zc_03.png')
                        },
                        {
                            name: '开心<br>汤圆粉',
                            img: require('@/assets/img/make_zc_04.png')
                        },
                        {
                            name: '团圆<br>汤圆粉',
                            img: require('@/assets/img/make_zc_05.png')
                        }
                    ]
                },
                {
                    title: require('@/assets/img/select_title_03.png'),
                    list: [
                        {
                            name: type === 'salt' ? '鸡肉' : '花生',
                            img: require(`@/assets/img/${type}_pl_01.png`)
                        },
                        {
                            name: type === 'salt' ? '菜肉' : '芝麻',
                            img: require(`@/assets/img/${type}_pl_02.png`)
                        },
                        {
                            name: type === 'salt' ? '虾球' : '果酱',
                            img: require(`@/assets/img/${type}_pl_03.png`)
                        },
                        {
                            name: type === 'salt' ? '猪肉' : '朱古力',
                            img: require(`@/assets/img/${type}_pl_04.png`)
                        },
                        {
                            name: type === 'salt' ? '芥菜' : '核桃仁',
                            img: require(`@/assets/img/${type}_pl_05.png`)
                        }
                    ]
                },
                {
                    title: require('@/assets/img/select_title_02.png'),
                    list: [
                        {
                            name: type === 'salt' ? '盐' : '白砂糖',
                            img: require(`@/assets/img/${type}_fl_01.png`)
                        },
                        {
                            name: type === 'salt' ? '小葱' : '细砂糖',
                            img: require(`@/assets/img/${type}_fl_02.png`)
                        },
                        {
                            name: type === 'salt' ? '鸡精' : '红糖',
                            img: require(`@/assets/img/${type}_fl_03.png`)
                        },
                        {
                            name: type === 'salt' ? '胡椒粉' : '黄砂糖',
                            img: require(`@/assets/img/${type}_fl_04.png`)
                        },
                        {
                            name: '油',
                            img: require(`@/assets/img/${type}_fl_05.png`)
                        }
                    ]
                }
            ]
        },
        select (index: number, clIndex: number) {
            let newVal = JSON.parse(JSON.stringify(this.selects))[index]
            if (newVal && newVal.indexOf(clIndex) > -1) {
                newVal.splice(newVal.indexOf(clIndex), 1)
                this.selects[index] = newVal
            } else {
                this.selects[index] = newVal ? newVal.concat([clIndex]) : [clIndex]
            }
            this.allSelected = this.selects.filter((val: number[]) => {
                return val !== undefined && val !== null && val.length > 0
            }).length == 3
        },
        makeTy () {
            if (!this.allSelected) {
                this.$common.toast('请选择汤圆的主料、配料、辅料再“制作汤圆”。')
                return
            }
            this.$common.track('click', '制作汤圆')
            this.getHb()
        },
        getHb () {
            if (this.isGeting) return
            this.isGeting = true
            this.SET_DIALOGDATA({
                text: '甜蜜汤圆制作中，请稍等...'
            })
            this.$request('/lottery/luck', {
                aid: this.aid,
                userinfo: this.userInfo
            }, 'post').then((data: any) => {
                data.amount = (data.amount / 100).toFixed(2)
                this.SET_HBDATA(data)
                this.$router.push({
                    path: '/complete'
                })
                this.SET_DIALOGDATA(null)
                this.isGeting = false
            }).catch((res: any) => {
                if (res && res.errno == 1010) {
                    this.$common.toast('亲，请完成安全验证')
                } else {
                    this.SET_HBDATA({
                        blessing: this.blessings[Math.floor(Math.random() * this.blessings.length)]
                    })
                    this.$router.push({
                        path: '/complete'
                    })
                }
                this.SET_DIALOGDATA(null)
                this.isGeting = false
            })
        },
    }
})
export default class Select extends Vue {}
